import pako from "pako";

export const reportData = async (event: string, properties?: any) => {
	const token = "72b086e1d9f67ed6";
	const config = useAppConfig();
	const data = {
		// 用户标识（固定值，确保所有事件归到同一用户）
		distinct_id: "HAKKO-AI-OFFICIALWEBSITE",
		anonymous_id: "HAKKO-AI-OFFICIALWEBSITE", // 匿名ID（与distinct_id相同）

		// 事件核心字段
		event: event, // 事件名称（神策预定义事件，自动统计PV）
		type: "track", // 固定为 track
		time: Date.now(), // 当前时间戳（毫秒）

		// 身份关联（简化版，与distinct_id一致）
		identities: {
			$identity_anonymous_id: "HAKKO-AI-OFFICIALWEBSITE",
		},

		// SDK信息（根据你的实际技术栈调整）
		lib: {
			$lib: "Javascript", // 平台改为 Web
			$lib_version: "1.0.0", // 你的前端版本号
			$app_version: "1.0.0", // 应用版本（可选）
		},

		// 页面属性（关键字段）
		properties: {
			$url: window.location.href, // 当前页面URL（神策预定义属性）
			$title: document.title, // 页面标题
			$referrer: document.referrer, // 来源页面（可选）
			...properties,
		},
	};
	const requestData = await encodeSensorData(data, true);
	// 使用fetch发送数据
	fetch(
		`${config.appConfig.saBaseUrl}sa?project=${config.appConfig.test == "production" ? "production" : "default"}&token=${token}`,
		{
			method: "POST",
			body: requestData,
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
			},
			mode: "no-cors",
			credentials: "omit",
		},
	)
		.then(async response => {})
		.catch(error => {
			console.log("Error:", error);
		});
};

async function encodeSensorData(jsonData: any, useGzip = false) {
	// Step 1: 生成 UTF-8 编码的 JSON 字符串
	const jsonStr = JSON.stringify(jsonData);

	// Step 2: Gzip 压缩（可选）
	let compressedData;
	if (useGzip) {
		const utf8Encoder = new TextEncoder();
		const compressed = pako.gzip(utf8Encoder.encode(jsonStr));
		compressedData = compressed;
	} else {
		compressedData = new TextEncoder().encode(jsonStr);
	}

	// Step 3: Base64 编码（必须）
	const base64Data = btoa(String.fromCharCode(...new Uint8Array(compressedData)));

	// Step 4: URLEncode 编码（必须）
	const urlEncodedData = encodeURIComponent(base64Data);

	// Step 5: 拼装请求参数
	return `data=${urlEncodedData}&gzip=${useGzip ? 1 : 0}`;
}
